module.exports = __webpack_public_path__ + "media/crypto/xlm-73519cfe.png";